<template>
  <div class="to-footer">
    <div class="footer">
      <div class="container">
        <div class="container-left">
          <div>
            <h3>安友云控</h3>
            <p key="2-4" @click="open('/ayyk/pageA')">人脸识别</p>
            <p key="2-5" @click="open('/ayyk/pageB')">人员管理</p>
            <p key="2-6" @click="open('/ayyk/pageC')">车辆管理</p>
            <p key="2-7" @click="open('/ayyk/pageD')">环境管理</p>
            <p key="2-8" @click="open('/ayyk/pageE')">现场管理</p>
          </div>
          <div>
            <h3>安友云联</h3>
            <p key="2-2" @click="handlePath(1)">智慧工地系统</p>
            <p key="2-1" @click="handlePath(2)">智能建造系统</p>
            <p key="2-3" @click="handlePath(3)">数智劳务系统</p>
            <p key="2-4" @click="handlePath(4)">物料智能验收系统</p>
            <p key="2-5" @click="handlePath(5)">网约车接乘系统</p>
            <p key="2-6" @click="handlePath(6)">重点访客及车辆预约管理系统</p>
            <p key="2-7" @click="handlePath(7)">社区管理系统</p>
            <p key="2-8" @click="handlePath(8)">安全教育培训系统</p>
          </div>
          <div>
            <h3>解决方案</h3>
            <p key="6-1" @click="open('/jjfa/gcjs')">工程建设</p>
            <p key="6-2" @click="open('/jjfa/yqgk')">园区管控</p>
          </div>
          <div>
            <h3>关于我们</h3>
            <p key="7-1" @click="open('/about')">公司简介</p>
            <p key="7-2" @click="open('/about')">资质证书</p>
            <p key="7-3" @click="open('/about')">合作伙伴</p>
          </div>
        </div>
        <div class="container-right">
          <div class="lxfs">
            <div>商务咨询</div>
            <p>0512-69577920转801</p>
            <div>渠道咨询</div>
            <p>0512-69577920转809</p>
            <div>售后咨询</div>
            <p>0512-65372516</p>
          </div>
          <div class="qcode">
            <img src="http://anyouyun.cn/officialWeb/v2/index/qcode1.png" width="120">
            <div>公众号</div>
          </div>
          <div class="qcode">
            <img src="http://anyouyun.cn/officialWeb/v2/index/qcode2.png" width="120">
            <div>抖音号</div>
          </div>
          <div class="qcode">
            <img src="http://anyouyun.cn/officialWeb/v2/index/qcode3.png" width="120">
            <div>安友商城</div>
          </div>
        </div>
      </div>
      <div class="information">
        <div>Copyright ©2019-2027 中友智控科技（苏州）有限公司 版权所有</div>
        <div @click="url">备案号: 苏ICP备2021007546号</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    data(){
      return {
      }
    },
    methods: {
      open(router){
        this.$router.push(router)
      },
      url(){
        window.open('https://beian.miit.gov.cn/', '_blank')
      },
      handlePath(index){
        this.$router.push('/ayyl/platform_' + index)
      }
    }
  }
</script>

<style lang="less" scoped>
.to-footer {
  background-color: #161b25;
  color: #FFF;
  padding: 40px 0 20px 0;
  .footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    .container {
      display: flex;
      .container-left {
        width: 700px;
        display: flex;
        justify-content: space-around;
        border-right: 1px solid #4d4d4d;
        padding: 0 20px;
      }
      .container-right {
        width: 700px;
        padding: 0 20px;
        display: flex;
        .lxfs {
          width: 240px;
          margin: 0px 20px;
          text-align: center;
          div {
            color: #b2b2b2;
            font-size: 18px;
          }
          p {
            font-size: 16px;
            color: #FFF;
          }
        }
        .qcode {
          width: 160px;
          text-align: center;
          div {
            color: #b2b2b2;
            margin-top: 20px;
          }
        }
      }
    }
    .information {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      div {
        margin: 0 40px;
        cursor: pointer;
      }
    }
  }
  h3 {
    margin-bottom: 10px;
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    text-align: center;
  }
  p {
    color: #b2b2b2;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
  }
  p:hover {
    color: #ffb575;
  }
}
</style>